export default "__VITE_ASSET__CFAuLGG___"